(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-study-accordion"]) return;
  try {
    
  (function () {
    function initAccordion(root) {
      var list = root.querySelector('[data-cs-list]');
      var labels = Array.prototype.slice.call(root.querySelectorAll('[data-cs-label]'));
      var images = Array.prototype.slice.call(root.querySelectorAll('[data-cs-image]'));
      var bodiesDesktop = Array.prototype.slice.call(root.querySelectorAll('[data-cs-body-desktop]'));
      var bodiesMobile = Array.prototype.slice.call(root.querySelectorAll('[data-cs-body-mobile]'));
      if (!labels.length) return;

      var desktopQuery = window.matchMedia('(min-width: 990px)');

      function setImage(key) {
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.dataset.step === key);
        });
      }

      function updateAria(label) {
        var active = label.classList.contains('is-active');
        if (desktopQuery.matches) {
          label.setAttribute('role', 'tab');
          label.setAttribute('aria-selected', active ? 'true' : 'false');
          label.setAttribute('tabindex', active ? '0' : '-1');
          label.removeAttribute('aria-expanded');
          label.setAttribute('aria-controls', label.dataset.desktopBodyId);
        } else {
          label.removeAttribute('role');
          label.removeAttribute('aria-selected');
          label.removeAttribute('tabindex');
          label.setAttribute('aria-expanded', active ? 'true' : 'false');
          label.setAttribute('aria-controls', label.dataset.mobileBodyId);
        }
      }

      // Desktop tab pattern: exactly one active, switching only, never closes.
      function setActiveDesktop(key) {
        setImage(key);
        bodiesDesktop.forEach(function (body) {
          body.classList.toggle('is-active', body.dataset.step === key);
        });
        labels.forEach(function (label) {
          label.classList.toggle('is-active', label.dataset.step === key);
          updateAria(label);
        });
      }

      // Mobile disclosure pattern: independent per-row open/closed, any
      // number open including zero. Opening one closes any other that was
      // open, and updates the shared image. Closing only closes — the
      // image is left showing whatever was last opened.
      function setMobileOpen(key, open) {
        if (open) {
          labels.forEach(function (other) {
            if (other.dataset.step !== key && other.classList.contains('is-active')) {
              setMobileOpen(other.dataset.step, false);
            }
          });
          setImage(key);
        }
        labels.forEach(function (label) {
          if (label.dataset.step !== key) return;
          label.classList.toggle('is-active', open);
          updateAria(label);
        });
        bodiesMobile.forEach(function (body) {
          if (body.dataset.step !== key) return;
          if (open) {
            // `hidden` is the real show/hide; is-open is purely the
            // cosmetic fade-in, applied a frame after unhiding so the
            // transition actually has something to animate from.
            body.hidden = false;
            body.classList.remove('is-open');
            requestAnimationFrame(function () {
              body.classList.add('is-open');
            });
          } else {
            body.classList.remove('is-open');
            body.hidden = true;
          }
        });
      }

      labels.forEach(function (label) {
        label.addEventListener('click', function () {
          var key = label.dataset.step;
          if (desktopQuery.matches) {
            setActiveDesktop(key);
            return;
          }
          setMobileOpen(key, !label.classList.contains('is-active'));
        });
      });

      if (list) {
        list.addEventListener('keydown', function (event) {
          if (!desktopQuery.matches) return;
          var keys = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'];
          if (keys.indexOf(event.key) === -1) return;
          var currentIndex = labels.findIndex(function (l) { return l.classList.contains('is-active'); });
          var nextIndex = currentIndex;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % labels.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + labels.length) % labels.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = labels.length - 1;
          event.preventDefault();
          var next = labels[nextIndex];
          setActiveDesktop(next.dataset.step);
          next.focus();
        });
      }

      function applyMode() {
        if (list) list.setAttribute('role', desktopQuery.matches ? 'tablist' : 'list');
        labels.forEach(updateAria);
      }

      desktopQuery.addEventListener('change', applyMode);
      applyMode();
    }

    document.querySelectorAll('[data-cs-accordion]').forEach(initAccordion);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Normalises the website field to include a scheme at submit time —
    // never blocks submission either way, matching the brief's "no
    // client-side validation beyond not-empty" rule. This is the closest
    // available equivalent to a server-side fixup: Shopify's native
    // contact form posts straight to Shopify's own backend, with no
    // theme code in the path afterward to normalise the stored value.
    document.querySelectorAll('[data-website-field]').forEach(function (field) {
      var form = field.closest('form');
      if (!form) return;
      form.addEventListener('submit', function () {
        var value = field.value.trim();
        if (value && !/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) {
          field.value = 'https://' + value;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.faq__item').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        var name = item.getAttribute('name');
        document.querySelectorAll('.faq__item[name="' + name + '"]').forEach(function (sibling) {
          if (sibling !== item) sibling.open = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function focusableEls(container) {
      return Array.prototype.slice
        .call(container.querySelectorAll('a[href], button:not([disabled])'))
        .filter(function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0;
        });
    }

    function trapFocus(container, event) {
      if (event.key !== 'Tab') return;
      var items = focusableEls(container);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    // Desktop mega menus — click to open, click-outside/Escape to close
    function setupDisclosure(trigger, panel) {
      function open() {
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        var items = focusableEls(panel);
        if (items.length) items[0].focus();
      }
      function close(returnFocus) {
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        if (returnFocus) trigger.focus();
      }
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          close(true);
        } else {
          open();
        }
      });
      panel.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          close(true);
        } else {
          trapFocus(panel, event);
        }
      });
      document.addEventListener('click', function (event) {
        if (
          trigger.getAttribute('aria-expanded') === 'true' &&
          !panel.contains(event.target) &&
          !trigger.contains(event.target)
        ) {
          close(false);
        }
      });
    }

    document.querySelectorAll('.site-header__mega-trigger').forEach(function (trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (panel) setupDisclosure(trigger, panel);
    });

    // Mobile full-screen panel — dedicated open/close controls, scroll lock, focus trap
    var openTrigger = document.querySelector('.site-header__trigger');
    var panel = document.getElementById('site-header-panel');
    var closeButton = panel ? panel.querySelector('.site-header__panel-close') : null;

    if (openTrigger && panel && closeButton) {
      var scrollLockCount = 0;

      function lockScroll() {
        if (scrollLockCount === 0) document.body.style.overflow = 'hidden';
        scrollLockCount++;
      }

      function unlockScroll() {
        scrollLockCount = Math.max(0, scrollLockCount - 1);
        if (scrollLockCount === 0) document.body.style.overflow = '';
      }

      function openPanel() {
        openTrigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        lockScroll();
        var items = focusableEls(panel);
        if (items.length) items[0].focus();
      }

      function closePanel() {
        openTrigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        unlockScroll();
        openTrigger.focus();
      }

      openTrigger.addEventListener('click', openPanel);
      closeButton.addEventListener('click', closePanel);
      panel.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closePanel();
        } else {
          trapFocus(panel, event);
        }
      });

      // Drill-down: tapping an item with children replaces the list with its
      // children + a back control. Only one view is visible at a time.
      var root = panel.querySelector('[data-panel-view="root"]');

      panel.querySelectorAll('[data-drill-open]').forEach(function (trigger) {
        var target = panel.querySelector('[data-panel-view="drill-' + trigger.getAttribute('data-drill-open') + '"]');
        if (!target) return;
        trigger.addEventListener('click', function () {
          if (root) root.hidden = true;
          target.hidden = false;
          var back = target.querySelector('.site-header__panel-back');
          if (back) back.focus();
        });
      });

      panel.querySelectorAll('.site-header__panel-back').forEach(function (back) {
        back.addEventListener('click', function () {
          var drill = back.closest('.site-header__panel-drill');
          if (drill) drill.hidden = true;
          if (root) {
            root.hidden = false;
            var first = root.querySelector('a, button');
            if (first) first.focus();
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var viewport = root.querySelector('[data-pt-viewport]');
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-pt-group]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pt-dot]'));
      if (!viewport || groups.length === 0 || dots.length === 0) return;

      var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      function setActive(index) {
        dots.forEach(function (dot, i) {
          if (i === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function closestGroupIndex() {
        var viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
        var closest = 0;
        var closestDistance = Infinity;
        groups.forEach(function (group, i) {
          var groupCenter = group.offsetLeft + group.offsetWidth / 2;
          var distance = Math.abs(groupCenter - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = i;
          }
        });
        return closest;
      }

      var scrollEndTimeout = null;
      viewport.addEventListener('scroll', function () {
        clearTimeout(scrollEndTimeout);
        scrollEndTimeout = setTimeout(function () {
          setActive(closestGroupIndex());
        }, 100);
      });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var group = groups[i];
          if (!group) return;
          viewport.scrollTo({
            left: group.offsetLeft,
            behavior: reduceMotionQuery.matches ? 'auto' : 'smooth',
          });
          setActive(i);
        });
      });
    }

    document.querySelectorAll('.partner-testimonials').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Real active-state toggle, not just a static "first pill looks
    // active" default — clicking any pill re-fills IT black and clears
    // the others, on top of letting the anchor's own default behaviour
    // scroll the page there. No preventDefault: this is additive to the
    // native #anchor jump, not a replacement for it.
    document.querySelectorAll('[data-services-pills]').forEach(function (row) {
      var pills = Array.prototype.slice.call(row.querySelectorAll('[data-services-pill]'));
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) {
            p.classList.toggle('is-active', p === pill);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonials(root) {
      var viewport = root.querySelector('[data-testimonials-viewport]');
      var track = root.querySelector('[data-testimonials-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-testimonials-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-testimonials-dot]'));
      var announcer = root.querySelector('[data-testimonials-announcer]');
      if (!viewport || !track || slides.length === 0) return;

      var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var desktopQuery = window.matchMedia('(min-width: 990px)');
      var autorotateSeconds = parseFloat(root.getAttribute('data-autorotate')) || 8;
      var currentIndex = 0;
      var timer = null;
      var announceTimeout = null;

      function scrollToIndex(index, smooth) {
        var slide = slides[index];
        if (!slide) return;
        viewport.scrollTo({
          left: slide.offsetLeft,
          behavior: smooth && !reduceMotionQuery.matches ? 'smooth' : 'auto',
        });
      }

      function setActive(index, announce) {
        if (index === currentIndex && !announce) return;
        currentIndex = index;
        dots.forEach(function (dot, i) {
          if (i === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        if (announcer) {
          clearTimeout(announceTimeout);
          announceTimeout = setTimeout(function () {
            announcer.textContent = 'Testimonial ' + (index + 1) + ' of ' + slides.length;
          }, 150);
        }
      }

      function currentVisibleIndex() {
        var viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
        var closest = 0;
        var closestDistance = Infinity;
        slides.forEach(function (slide, i) {
          var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          var distance = Math.abs(slideCenter - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = i;
          }
        });
        return closest;
      }

      var scrollEndTimeout = null;
      viewport.addEventListener('scroll', function () {
        clearTimeout(scrollEndTimeout);
        scrollEndTimeout = setTimeout(function () {
          setActive(currentVisibleIndex(), true);
        }, 100);
      });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          scrollToIndex(i, true);
          setActive(i, true);
          restartAutorotate();
        });
      });

      function stopAutorotate() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startAutorotate() {
        stopAutorotate();
        if (slides.length < 2) return;
        if (!desktopQuery.matches) return;
        if (reduceMotionQuery.matches) return;
        timer = setInterval(function () {
          var next = (currentIndex + 1) % slides.length;
          scrollToIndex(next, true);
          setActive(next, true);
        }, autorotateSeconds * 1000);
      }

      function restartAutorotate() {
        startAutorotate();
      }

      root.addEventListener('mouseenter', stopAutorotate);
      root.addEventListener('mouseleave', startAutorotate);
      root.addEventListener('focusin', stopAutorotate);
      root.addEventListener('focusout', startAutorotate);

      desktopQuery.addEventListener('change', startAutorotate);
      reduceMotionQuery.addEventListener('change', startAutorotate);

      startAutorotate();
    }

    function initAll() {
      document.querySelectorAll('[data-testimonials]').forEach(function (root) {
        if (root.dataset.testimonialsInitialized) return;
        root.dataset.testimonialsInitialized = 'true';
        initTestimonials(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["work-projects"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFilters(root) {
      var filters = Array.prototype.slice.call(root.querySelectorAll('[data-wp-filter]'));
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-wp-row]'));
      var heading = root.querySelector('[data-wp-heading]');
      var count = root.querySelector('[data-wp-count]');
      if (filters.length === 0 || !heading || !count) return;

      var allProjectsHTML = heading.innerHTML;

      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var category = btn.getAttribute('data-category') || '';

          filters.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });

          var visible = 0;
          rows.forEach(function (row) {
            var rowCategories = (row.getAttribute('data-categories') || '').split('|');
            var matches = category === '' || rowCategories.indexOf(category) !== -1;
            row.hidden = !matches;
            if (matches) visible += 1;
          });

          if (category === '') {
            heading.innerHTML = allProjectsHTML;
          } else {
            heading.textContent = category;
          }
          count.textContent = visible;
        });
      });
    }

    function initPreview(root) {
      var pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      if (!pointerQuery.matches) return;

      var list = root.querySelector('[data-wp-list]');
      var preview = root.querySelector('[data-wp-preview]');
      var previewImg = root.querySelector('[data-wp-preview-img]');
      if (!list || !preview || !previewImg) return;

      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-wp-row]'));
      rows.forEach(function (row) {
        var src = row.getAttribute('data-preview-image');
        if (src) {
          var warm = new Image();
          warm.src = src;
        }
      });

      var OFFSET = 20;
      var PREVIEW_W = 335;
      var PREVIEW_H = 194;
      var currentRow = null;
      var pendingX = 0;
      var pendingY = 0;
      var rafId = null;

      function setPosition(x, y) {
        var left = x + OFFSET;
        var top = y + OFFSET;
        if (left + PREVIEW_W > window.innerWidth) {
          left = x - OFFSET - PREVIEW_W;
        }
        if (top + PREVIEW_H > window.innerHeight) {
          top = y - OFFSET - PREVIEW_H;
        }
        left = Math.max(0, Math.min(left, window.innerWidth - PREVIEW_W));
        top = Math.max(0, Math.min(top, window.innerHeight - PREVIEW_H));
        preview.style.transform = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
      }

      function scheduleUpdate() {
        if (rafId !== null) return;
        rafId = requestAnimationFrame(function () {
          rafId = null;
          setPosition(pendingX, pendingY);
        });
      }

      list.addEventListener('mouseover', function (event) {
        var row = event.target.closest('[data-wp-row]');
        if (!row || row === currentRow) return;
        currentRow = row;

        var src = row.getAttribute('data-preview-image');
        if (!src) {
          preview.classList.remove('is-visible');
          return;
        }

        previewImg.src = src;
        pendingX = event.clientX;
        pendingY = event.clientY;
        setPosition(event.clientX, event.clientY);
        preview.classList.add('is-visible');
      });

      list.addEventListener('mousemove', function (event) {
        pendingX = event.clientX;
        pendingY = event.clientY;
        if (currentRow) scheduleUpdate();
      });

      list.addEventListener('mouseleave', function () {
        currentRow = null;
        preview.classList.remove('is-visible');
      });
    }

    document.querySelectorAll('.work-projects').forEach(function (root) {
      initFilters(root);
      initPreview(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
